export interface PipelineCsvMarker {
  name: string;
  latitude: number;
  longitude: number;
  trackState: string;
  description: string;
  sortOrder?: number;
}

function csvEscape(value: string): string {
  if (value.includes(',') || value.includes('"') || value.includes('\n')) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

export function buildPipelineImportCsv(markers: PipelineCsvMarker[]): string {
  const sorted = [...markers].sort(
    (a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0)
  );
  const lines = ['AGM Marker Name,Latitude,Longitude,State,Description'];
  for (const marker of sorted) {
    const description = marker.description || 'AGM';
    const state = marker.trackState === 'S' ? 'SKIP' : 'TRACK';
    lines.push(
      [
        csvEscape(marker.name || ''),
        marker.latitude,
        marker.longitude,
        state,
        csvEscape(description),
      ].join(',')
    );
  }
  return lines.join('\r\n') + '\r\n';
}

export function sanitizeCsvFilename(name: string): string {
  const sanitized = name.replace(/[<>:"/\\|?*]/g, '_').trim();
  return sanitized || 'pipeline';
}

export function triggerCsvDownload(content: string, filename: string): void {
  const anchorElement = document.createElement('a');
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  anchorElement.href = url;
  anchorElement.setAttribute('download', filename);
  anchorElement.click();
  URL.revokeObjectURL(url);
}
